module.exports = __webpack_public_path__ + "img/zat-gun.1a4e70f6.svg";